import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemStatusComponent } from '../../components/item-status/item-status.component';
import { ItemMessengerComponent } from '../../components/item-messenger/item-messenger.component';
import { InputSwitchNewComponent } from '../../components/input-switch-new/input-switch-new.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import ModalService from '../../services/modal.service';
import StatusService from '../../services/status.service';
import Session from '../../utils/session.service';
import ChatRestServices from '../../services/chat-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'item-conversation',
	templateUrl: './item-conversation.component.html',
	imports: [ CommonModule, TranslatePipe, ItemStatusComponent, ItemMessengerComponent, InputSwitchNewComponent, FormsModule ]
})
export class ItemConversationComponent implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private modalService: ModalService = inject(ModalService);
	private statusService: StatusService = inject(StatusService);
	private session: Session = inject(Session);
	private chatRestServices: ChatRestServices = inject(ChatRestServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() isInfoHidden: any | undefined;
	@Output() isInfoHiddenChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	@Input() chat: any;
	
	vm: any = undefined;
	watcher: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.mediaOpen = [];
		this.handleStatusUpdate(this.statusService.getStatuses());
		this.vm.user = this.session.getSession().user;
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(
				this, this.config.getBroadcastConfig().Modal.MEDIA_OPEN,
				(e, data) => {
					this.handleMediaOpen(e, data);
				})
		);
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(
				this, this.config.getBroadcastConfig().Modal.MEDIA_CLOSING,
				(e, data) => {
					this.handleMediaClosing(e, data);
				})
		);
		
		var currentStatuses = [];
		this.watcher = this.angularHelperService.createInterval(() => {
			var newStatuses = this.statusService.getStatuses();
			if (!this.angularHelperService.isEqual(newStatuses, currentStatuses)) {
				console.log("Statuses updated", currentStatuses, newStatuses);
				currentStatuses = newStatuses;
				this.handleStatusUpdate(newStatuses);
			}
		}, 300);
		
		this.vm.close = this.close;
		this.vm.toggleChatDisabled = this.toggleChatDisabled;
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	handleStatusUpdate(statuses) {
		var id: any = this.vm.chat.privateChatFriend.id;
		if (statuses[id]) this.vm.chat.privateChatFriend.status = statuses[id].status;
	}
	
	toggleChatDisabled = (): void => {
		this.chatRestServices.toggleChatDisabled({
			id: this.vm.chat.id
		}).then(() => {
			this.vm.chat.disabled = !this.vm.chat.disabled;
		}).catch((error) => {
			console.log(error);
		});
	}
	
	handleMediaOpen(e, data) {
		if (!data.id || !data.chat || data.chat !== this.vm.chat.id) return;
		this.vm.mediaOpen.push(data.id);
	}
	
	handleMediaClosing(e, data) {
		if (!data.id || !data.chat || data.chat !== this.vm.chat.id) return;
		this.vm.mediaOpen = this.vm.mediaOpen.filter((media) => { return media !== data.id; });
	}
	
	close() {
		this.vm.mediaOpen.forEach((media) => {
			this.modalService.close(media);
		});
		this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Chat.CLOSE, this.vm.chat);
	}
	
}